import { inject } from '@angular/core';
import {
    HttpContextToken,
    HttpErrorResponse,
    HttpEvent,
    HttpEventType,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ToastService } from '@snelstart/ui-toast';

export const USE_HTTP_LOGGING_INTERCEPTOR = new HttpContextToken<boolean>(() => true);
export const USE_HTTP_VERBOSE_LOGGING = new HttpContextToken<boolean>(() => true);
export const USE_HTTP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => true);

export const httpLoggingInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    if (!request.context.get(USE_HTTP_LOGGING_INTERCEPTOR)) {
        return next(request);
    }

    const startTime = Date.now();
    const verboseLogging = request.context.get(USE_HTTP_VERBOSE_LOGGING);

    if (verboseLogging) {
        console.debug(`Sending request: ${request.urlWithParams} (Method: ${request.method})`);
    }

    return next(request).pipe(
        tap({
            next: (event: HttpEvent<unknown>) => {
                if (verboseLogging && event.type === HttpEventType.Response) {
                    const elapsed = Date.now() - startTime;
                    console.debug(`Request successful: ${request.urlWithParams} (Time elapsed: ${elapsed} ms)`, event.body);
                }
            },
            error: (error: HttpErrorResponse): void => {
                const elapsed = Date.now() - startTime;
                console.error(`Request failed: ${request.urlWithParams} (Time elapsed: ${elapsed} ms)`, error);
            },
        }),
    );
};

export const httpErrorInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    if (!request.context.get(USE_HTTP_ERROR_INTERCEPTOR)) {
        return next(request);
    }

    const toastService = inject(ToastService);

    return next(request).pipe(
        tap({
            error: (error: HttpErrorResponse): void => {
                console.error(error);
                if (error.status !== 400 && error.status !== 404) {
                    toastService.showErrorMessage(error.message);
                }
            },
        }),
    );
};
